import React from "react";

//external components
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

//components
import TenantForm from "../../Tenants-form";
import EmployeesList from "../../../Employees/Employees-list";
import CompanyList from "../../../Companies/Companies-list";
import TenantManagement from "../../Tenants-form/components/tenantManagement";
import TenantLicenses from "../../Tenants-licenses";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 0.5, pb: 0.5 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function TenantTabRoutes({ value, fromTenant }) {
  return (
    <>
      <TabPanel value={value} index={0}>
        <TenantForm fromTenant={fromTenant} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <TenantLicenses fromTenant={fromTenant} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <CompanyList fromTenant={fromTenant} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <EmployeesList fromTenant={fromTenant} />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <TenantManagement fromTenant={fromTenant} />
      </TabPanel>
    </>
  );
}
